import React, { useState } from 'react';

// Utils
import { mediaQueries, fromTablethoriMediaQuery } from 'utils/MediaQueriesDeprecated';
import { Routes } from 'utils/routes';

// Components
import { TrustRatings, Spacer, ContentBoxContainer, ContentBoxText, ContentBoxFigure, PenlySeo, VideoPlayer, Button, PageFAQ, Testimonials } from 'components';

// FAQ texts
import { pricesPageFAQEntries } from 'utils/texts';
import ProductBoxContainer from '../../src/components/Products/ProductBoxContainer';
import { TOTAL_NUMBER_OF_USERS } from '../../src/constants';

export default function Partners() {
    const title = 'Opret en gratis profil på Penly og køb hjælp når du har brug for det';
    const description = 'På Penly får du adgang til digitale analyser af din økonomi. Når du har brug for hjælp, kan du bestille uvildig rådgivning til attraktive priser. Se mere.';
    const image = { url: '/static/gfx/content/penly-content-4.jpg' };
    const fromTablethori = mediaQueries(fromTablethoriMediaQuery);

    // State
    const [showVideoDialog, setShowVideoDialog] = useState(false);



    const toggleVideo = () => {
        setShowVideoDialog(!showVideoDialog);
    };
    return (
        <>
            <PenlySeo title={ title } description={ description } image={ image } />
            <ContentBoxContainer className="fluid">
                <ContentBoxText>
                    <h1 className="nomb">
                        Økonomi behøver ikke at være uoverskueligt
                    </h1>
                    <p className="large">
                        Vi tygger os igennem alle de tørre tal og giver dig konkrete anbefalinger til, hvordan du kan optimere din økonomi.
                    </p>
                </ContentBoxText>
                <ContentBoxFigure className="penlylogoSymbol"></ContentBoxFigure>
            </ContentBoxContainer>
            <ProductBoxContainer/>
            <article>
                <h2 style={{ textAlign: 'center' }} className="color-primary">
                    Mere end <span className="color-highlight">{ TOTAL_NUMBER_OF_USERS }</span> danskere har allerede analyseret deres
                    pension med Penly
                </h2>
                <TrustRatings/>
                <Testimonials/>
            </article>


            <ContentBoxContainer className="background-primary brbr brtl">
                <ContentBoxText>
                    <h3>Vi udvikler de værktøjer vi selv har manglet</h3>
                    <p className="large">
                        Vores vision er at samle alle dine tal på tværs af realkredit, pension, formue og gæld og hjælpe dig til at forstå regnestykket.
                    </p>
                    <h4>
                        Penly <span className="color-highlight">RealkreditTjek</span>
                    </h4>
                    <p>Hvornår kan det betale sig at lægge dit lån om?</p>
                    <h4>
                        Penly <span className="color-highlight">InvestTjek</span>
                    </h4>
                    <p>Gå ikke glip af fremtidigt afkast.</p>
                </ContentBoxText>
                <ContentBoxFigure figure="/static/gfx/content/penly-content-13.jpg" className="brbl"></ContentBoxFigure>
            </ContentBoxContainer>
            { fromTablethori ? <Spacer size="huge" /> : <Spacer /> }

            <Spacer size="large" />

            <ContentBoxContainer className="center">
                <ContentBoxText className="brbr single80 background-highlight">
                    <h3>Kom i gang med dit pensionstjek på 5 minutter</h3>
                    <p className="large">
                        Prøv vores gratis pensionsberegner, og følg med i om din pension vokser, som den skal.
                    </p>
                    <Spacer size="small" />
                    <div>
                        <Button color="white" href={ Routes.PensionCheck.Start }>
                            Ja tak, lad mig prøve
                        </Button>
                    </div>
                </ContentBoxText>
            </ContentBoxContainer>

            <Spacer size="large" />

            <ContentBoxContainer className="single">
                <ContentBoxText className="prices-affiliates">
                    <h3 className="color-primary">Vi samarbejder med</h3>
                    <div>
                        <a href="https://taenk.dk/" target="_new">
                            <img src="/static/gfx/content/affiliates/forbrugerraadet-taenk-logo.svg" alt="Penly - Samarbejde med Forbrugerrådet Tænk" />
                        </a>
                        <a href="https://fagligsenior.dk/" target="_new">
                            <img src="/static/gfx/content/affiliates/faglige-seniorer-logo.svg" alt="Penly - Samarbejde med Faglige Seniorer" />
                        </a>
                        <a href="https://moneypennyandmore.dk/" target="_new">
                            <img src="/static/gfx/content/affiliates/moneypenny-and-more-logo.png" alt="Penly - Samarbejde med Moneypenny &amp; More" />
                        </a>
                    </div>
                </ContentBoxText>
            </ContentBoxContainer>

            <Spacer size="large" />

            <ContentBoxContainer>
                <ContentBoxFigure figure="/static/gfx/content/penly-content-hero-2.jpg" className="brtl servicelogoinline colorWhite" onClick={ () => toggleVideo() }>
                    <div className="videoPlay">
                        <img src="/static/gfx/PlayIcon.svg" />
                        Se filmen om PensionsTjek
                    </div>
                </ContentBoxFigure>
                <ContentBoxText className="background-primary brbr">
                    <h3>Pension behøver ikke at være uoverskueligt eller kedeligt</h3>
                    <ol className="large">
                        <li>Opret en profil og upload dine pensionsdata med NemID.</li>
                        <li>Se hvordan du kan få dine pensioner til at vokse hurtigere.</li>
                        <li>Få evt. hjælp af en uvildig rådgiver til at føre anbefalingerne ud i livet.</li>
                    </ol>
                    <Button href={ Routes.PensionCheck.Start } color="white" size="large">
                        Tag et PensionsTjek nu
                    </Button>
                </ContentBoxText>
            </ContentBoxContainer>
            { showVideoDialog && (
                <div className="modalOverlay" onClick={ () => toggleVideo() }>
                    <VideoPlayer videoId="yx8muiGvpi8" autoPlay={ true } />
                </div>
            ) }

            <Spacer size="large" />

            <PageFAQ title="FAQ om uvildig rådgivning igennem Penly" faqEntries={ pricesPageFAQEntries } />

            <Spacer size="medium" />
        </>
    );
}
